import clsx from 'clsx';
import { BlockUI, type BlockUIPassThroughOptions } from 'primereact/blockui';
import { ProgressBar } from 'primereact/progressbar';
import styles from './loading-blocker.module.css';

interface Props {
	blocked: boolean;
	className?: string;
	color?: string;
	children: React.ReactNode;
	blockTemplate?: React.ReactNode;
	pt?: BlockUIPassThroughOptions;
	thin?: boolean;
	full?: boolean;
}

const LoadingBlocker = ({
	children,
	className,
	color = '#0080FF',
	blocked,
	blockTemplate,
	thin = false,
	full = false,
	pt,
}: Props) => {
	return (
		<>
			<div
				className={clsx(
					className,
					styles.progressBarContainer,
					thin && styles.thin,
					!blocked && 'hidden',
					!full && 'px-8',
				)}
			>
				<ProgressBar
					mode="indeterminate"
					color={color}
					className={clsx(styles.progressBar, thin && styles.thin)}
				/>
			</div>
			<BlockUI
				blocked={blocked}
				template={blockTemplate}
				className={styles.formBlock}
				pt={pt}
			>
				{children}
			</BlockUI>
		</>
	);
};

export default LoadingBlocker;
